import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Programa', href: '#sobre' },
  { label: 'Currículo', href: '#curriculo' },
  { label: 'Admissão', href: '#admissao' },
  { label: 'Cronograma', href: '#cronograma' },
  { label: 'Parceiros', href: '#parceiros' },
  { label: 'Contacto', href: '#contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setActiveLink(href);
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white border-b border-gray-100'
          : 'bg-gradient-to-b from-black/50 to-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-14">
        <div className="flex items-center justify-between h-20 md:h-24 gap-4">

          {/* ── LOGO UAN — esquerda ── */}
          <a
            href="#"
            className={`group flex items-center gap-3 flex-shrink-0 px-3 py-2 rounded-xl transition-all duration-300 ${
              scrolled ? 'hover:bg-gray-50' : 'hover:bg-white/10'
            }`}
          >
            <div className={`relative w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ring-2 bg-white ${
              scrolled
                ? 'ring-primary/20 group-hover:ring-primary/50'
                : 'ring-white/30 group-hover:ring-white/70'
            }`}>
              <img
                src="https://storage.readdy-site.link/project_files/ad23bf20-8f1c-4820-8d59-048f8dd2f26d/bd89f3d4-9272-492f-af40-413c072c76b4_UAN.png?v=685b157d5b4029017fe2ff5f6af1a6d7"
                alt="Universidade Agostinho Neto"
                className="w-9 h-9 md:w-11 md:h-11 object-contain"
              />
            </div>
            <div className="hidden lg:block">
              <p className={`text-xs font-bold tracking-wide leading-tight transition-colors ${scrolled ? 'text-primary' : 'text-white'}`}>
                UNIVERSIDADE
              </p>
              <p className={`text-xs font-bold tracking-wide leading-tight transition-colors ${scrolled ? 'text-primary' : 'text-white'}`}>
                AGOSTINHO NETO
              </p>
              <p className={`text-[10px] tracking-wider uppercase mt-0.5 transition-colors ${scrolled ? 'text-accent' : 'text-white/70'}`}>
                UAN · Angola
              </p>
            </div>
          </a>

          {/* ── LINKS DE NAVEGAÇÃO — centro ── */}
          <div className="hidden md:flex items-center gap-1 lg:gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                className={`relative group px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                  scrolled
                    ? 'text-gray-600 hover:text-primary hover:bg-primary/5'
                    : 'text-white/85 hover:text-white hover:bg-white/10'
                } ${activeLink === link.href ? (scrolled ? 'text-primary bg-primary/5' : 'text-white bg-white/10') : ''}`}
              >
                {link.label}
                {/* underline animado */}
                <span className={`absolute bottom-1 left-3 right-3 h-0.5 rounded-full transform origin-left transition-all duration-300 scale-x-0 group-hover:scale-x-100 ${
                  scrolled ? 'bg-accent' : 'bg-white/70'
                } ${activeLink === link.href ? 'scale-x-100' : ''}`} />
              </a>
            ))}

            {/* Botão CTA */}
            <a
              href="https://medumed.cedumed.ao/login/index.php"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-3 inline-flex items-center gap-1.5 px-4 py-2 bg-yellow-400 text-primary text-sm font-semibold rounded-full hover:bg-yellow-300 active:scale-95 transition-all duration-200 whitespace-nowrap"
            >
              Área do Aluno
              <i className="ri-user-line text-sm" />
            </a>
          </div>

          {/* ── LOGO FM — direita ── */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <a
              href="#"
              className={`group flex items-center gap-3 px-3 py-2 rounded-xl transition-all duration-300 ${
                scrolled ? 'hover:bg-gray-50' : 'hover:bg-white/10'
              }`}
            >
              <div className="hidden lg:block text-right">
                <p className={`text-xs font-bold tracking-wide leading-tight transition-colors ${scrolled ? 'text-primary' : 'text-white'}`}>
                  FACULDADE DE
                </p>
                <p className={`text-xs font-bold tracking-wide leading-tight transition-colors ${scrolled ? 'text-primary' : 'text-white'}`}>
                  MEDICINA
                </p>
                <p className={`text-[10px] tracking-wider uppercase mt-0.5 transition-colors ${scrolled ? 'text-accent' : 'text-white/70'}`}>
                  FM · UAN
                </p>
              </div>
              <div className={`relative w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ring-2 bg-white ${
                scrolled
                  ? 'ring-primary/20 group-hover:ring-primary/50'
                  : 'ring-white/30 group-hover:ring-white/70'
              }`}>
                <img
                  src="https://storage.readdy-site.link/project_files/ad23bf20-8f1c-4820-8d59-048f8dd2f26d/f8c09746-7b9a-4a69-960b-de62999d0ecf_FM.png?v=1f767ecbf0d1e1090d392e1a65a42bdf"
                  alt="Faculdade de Medicina"
                  className="w-9 h-9 md:w-11 md:h-11 object-contain"
                />
              </div>
            </a>

            {/* Botão hamburger mobile */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
                scrolled ? 'text-primary hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
            </button>
          </div>

        </div>
      </div>

      {/* ── MENU MOBILE ── */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-gray-700 hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 group"
              >
                <span className="w-1 h-1 rounded-full bg-accent opacity-0 group-hover:opacity-100 transition-opacity" />
                {link.label}
              </a>
            ))}
            <a
              href="#admissao"
              onClick={(e) => handleClick(e, '#admissao')}
              className="flex items-center justify-center gap-2 px-4 py-3 mt-2 text-sm font-semibold text-primary bg-yellow-400 hover:bg-yellow-300 rounded-lg transition-colors"
            >
              Área do Aluno
              <i className="ri-user-line" />
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
